import React from 'react';
import makeLoadable from '@loadable/component';
import RouterLoader from './RouterLoader';
import {routePaths} from './route-paths';
import AuthError from 'pages/auth/error';
import Auth0Callback from '@/auth/Auth0Callback';
import Logout from 'pages/auth/logout';
import Login from '@/auth/Login';
import Auth0Loading from '../auth/Auth0Loading';
import LoginOrRedirect from '../auth/LoginOrRedirect';
import SmsPermissions from 'pages/sms-permissions';

export function loadable(module) {
    return makeLoadable(module, {fallback: <RouterLoader />});
}

const componentsByPath = {
    '/auth/callback': Auth0Callback,
    '/auth/pending': Auth0Loading,
    '/auth/restricted-login': Login,
    '/login': Login,
    '/auth/partner-login': LoginOrRedirect,
    '/auth/error': AuthError,
    '/logout': Logout,
    '/sms-permissions': SmsPermissions,
};

const routes = routePaths.map(routePath => ({
    ...routePath,
    component: componentsByPath[routePath.path],
}));

export default routes;
